export default import.meta.ROLLDOWN_FILE_URL__5P8tfv_qMsMu6DX7YyMcA